// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedUser: null,
  errors: false,
  block: false
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        block: false
      }
    case 'GET_USER':
      return { ...state, selectedUser: action.selectedUser, block: false }
    case 'ADD_USER':
      return { ...state, errors: action.errors, status: action.status, block: false }
    case 'EDIT_USER':
      return { ...state, selectedUser: action.selectedUser, block: false }
    case 'CHANGE_STATUS_USER':
      return { ...state, selectedUser: action.selectedUser, block: false }
    case 'CHANGE_ROLE_USER':
      return { ...state, block: false }
    case 'GET_ALL_PERMISSIONS':
      return { ...state, allPermissions: action.data }
    case 'BLOCK':
      return { ...state, block: true }
    case 'UNBLOCK':
      return { ...state, block: false }
    default:
      return { ...state }
  }
}
export default users
